/* import __COLOCATED_TEMPLATE__ from './pills-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();